const DEFAULT_LIMIT = 20;
const STORAGE_KEY = "bulk-create-post-limit";

// Runtime storage (resets on page reload if not in localStorage)
let runtimeLimit: number | null = null;

export const getBulkCreateLimit = (): number => {
  // Priority: runtime override > localStorage > default
  if (runtimeLimit !== null) {
    return runtimeLimit;
  }

  const storedLimit = localStorage.getItem(STORAGE_KEY);
  if (storedLimit) {
    const parsed = parseInt(storedLimit, 10);
    if (!isNaN(parsed) && parsed > 0) {
      return parsed;
    }
  }

  return DEFAULT_LIMIT;
};

export const setBulkCreateLimit = (limit: number): void => {
  if (limit <= 0) {
    throw new Error("Limit must be greater than 0");
  }

  runtimeLimit = limit;
  localStorage.setItem(STORAGE_KEY, limit.toString());
  console.log(`✓ Bulk create limit set to ${limit}`);
};

export const resetBulkCreateLimit = (): void => {
  runtimeLimit = null;
  localStorage.removeItem(STORAGE_KEY);
  console.log(`✓ Bulk create limit reset to default (${DEFAULT_LIMIT})`);
};

// Global console function declarations
declare global {
  interface Window {
    setBulkCreateLimit: typeof setBulkCreateLimit;
    resetBulkCreateLimit: typeof resetBulkCreateLimit;
    getBulkCreateLimit: typeof getBulkCreateLimit;
  }
}

// Expose functions to window object for console usage
if (typeof window !== "undefined") {
  window.setBulkCreateLimit = setBulkCreateLimit;
  window.resetBulkCreateLimit = resetBulkCreateLimit;
  window.getBulkCreateLimit = getBulkCreateLimit;
}
